import type { ElementType, ReactNode } from "react";
import { cn } from "@/lib/utils";
import { useInView } from "@/hooks/useInView";

/**
 * Sanftes Einblenden mit leichtem vertikalem Versatz.
 * Bei prefers-reduced-motion greift die Transition per CSS nicht,
 * die Inhalte sind dann sofort vollständig sichtbar.
 */
export function Reveal({
  as: Tag = "div",
  delay = 0,
  className,
  children,
}: {
  as?: ElementType;
  delay?: number;
  className?: string;
  children: ReactNode;
}) {
  const { ref, inView } = useInView<HTMLDivElement>();

  return (
    <Tag
      ref={ref}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
      className={cn(
        "motion-safe:transition-all motion-safe:duration-700 motion-safe:ease-out",
        inView ? "opacity-100 translate-y-0" : "motion-safe:opacity-0 motion-safe:translate-y-6",
        className,
      )}
    >
      {children}
    </Tag>
  );
}
